import React from "react"

import { useDispatch } from "react-redux"

import AppBar from "@material-ui/core/AppBar"

import Toolbar from "@material-ui/core/Toolbar"
import { useNavigation } from "../navigation"
import { ToolbarLeft } from "./modal-screen"
import {
  CentralToolbarSection,
  LeftToolbarSection,
  RightToolbarSection,
} from "./nav-header"
import { MainSection, ScreenContainer } from "./screen"
import { ReactFC } from "types"

export const useClose = ({ onBeforeClose, route }) => {
  const navigation = useNavigation()
  const dispatch = useDispatch()
  if (typeof route === "function") {
    return route
  }

  const close = () => {
    if (typeof route === "string") {
      dispatch({ type: route })
    } else if (typeof route === "object") {
      dispatch(route)
    } else if (!process.env.REACT_APP_NO_LEGACY) {
      const { popModal } = require("state/actions/navigation")
      dispatch(popModal(navigation))
    }
  }
  if (!onBeforeClose) {
    return close
  }

  return async () => {
    try {
      await onBeforeClose()
      close()
    } catch (err) {
      console.error(err)
    }
  }
}

export interface ModalScreenLayoutProps {
  onBeforeClose?: any
  back?: any
  className?: any
  title?: React.ReactNode
  center?: React.ReactNode  
  titleLabel?: any
  left?: React.ReactNode
  right?: React.ReactNode
}

export const ModalScreenLayout: ReactFC<ModalScreenLayoutProps> = (props) => {
  const close = useClose({
    onBeforeClose: props.onBeforeClose,
    route: props.back,
  })

  const { className, right, children, left } = props

  return (
    <ScreenContainer className={className}>
     
      <AppBar elevation={0} position="static">
        <Toolbar>
          <LeftToolbarSection>
            <ToolbarLeft close={close} {...props}>
              {left}
            </ToolbarLeft>
          </LeftToolbarSection>
          <CentralToolbarSection />
          <RightToolbarSection>{right}</RightToolbarSection>
        </Toolbar>
      </AppBar>
      <MainSection bottomBar={false}>{children}</MainSection>
    </ScreenContainer>
  )
}

export default ModalScreenLayout

